import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import useAppStore from '../../stores/useAppStore';

interface RoleBasedRouteProps {
  children: React.ReactNode;
  allowedRoles: string[];
  redirectTo?: string;
  showLoginModal?: boolean;
}

export default function RoleBasedRoute({ 
  children, 
  allowedRoles,
  redirectTo = '/coming-soon', 
  showLoginModal = false 
}: RoleBasedRouteProps): JSX.Element | null {
  const { isAuthenticated, user, openLoginModalClean } = useAppStore();
  const navigate = useNavigate();

  useEffect(() => {
    if (!isAuthenticated) {
      if (showLoginModal) {
        // Show login modal instead of redirecting
        openLoginModalClean();
      } else {
        // Redirect to home for unauthenticated users
        navigate('/');
      }
      return;
    }

    // Check if user has the required role
    const userRole = user?.role || 'User';
    const hasRequiredRole = allowedRoles.includes(userRole);

    if (!hasRequiredRole) {
      // User doesn't have required role, redirect to appropriate page
      if (userRole === 'User' || !userRole) {
        navigate('/coming-soon');
      } else {
        navigate(redirectTo);
      }
    }
  }, [isAuthenticated, user, allowedRoles, navigate, redirectTo, showLoginModal, openLoginModalClean]);

  // If not authenticated, don't render the protected content
  if (!isAuthenticated) {
    return null;
  }

  // Check if user has the required role
  const userRole = user?.role || 'User';
  const hasRequiredRole = allowedRoles.includes(userRole);

  if (!hasRequiredRole) {
    return null;
  }

  return <>{children}</>;
}
